import { useState, useEffect } from "react";
import { CountryComponent_Plain } from "../../../types/components/shared/CountryComponent";
import "./Documents.scss";
import { FileBlockComponent_Plain } from "../../../types/components/shared/FileBlockComponent";
import { getStrapiMedia } from "../../../utils/utils";

const Documents = ({
  data,
  title,
}: {
  data: CountryComponent_Plain[];
  title: string;
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    updateTitle(data[activeTab].title, data[activeTab].document.length);
  }, [activeTab, data]);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    setIsOpen(false);
  };
  const handleTitleClick = () => {
    setIsOpen(!isOpen);
  };
  const updateTitle = (title: string, count: number) => {
    const titleElement = document.querySelector(".tabs-nav__title");
    if (titleElement) {
      titleElement.innerHTML = `${title} <span>(${count})</span>`;
    }
  };

  return (
    <section className="documents">
      <div className="wrapper">
        <h1 className="block-title">{title}</h1>

        <div className={`tabs tabs-with-title ${isOpen ? "opened-tabs" : ""}`}>
          <div className="box-tabs-title">
            <div className="tabs-nav__title" onClick={handleTitleClick}></div>
          </div>
          <ul className="tabs-nav">
            {data.map((country, index) => (
              <li
                key={index}
                className={`tabs-nav__item ${activeTab === index ? "active" : ""}`}
              >
                <a href={`#${index}`} onClick={() => handleTabClick(index)}>
                  {country.title} <span>({country.document.length})</span>
                </a>
              </li>
            ))}
          </ul>
          <div className="tabs-content">
            <div className="document-list">
              {data[activeTab]?.document.map(
                (
                  documentItem: FileBlockComponent_Plain,
                  documentKey: number,
                ) => (
                  <div key={documentKey} className="document-list__item">
                    <div className="document-list__name">
                      {documentItem.name}
                    </div>
                    <div className="document-list__bottom">
                      <div className="document-list__bottom-left">
                        {(documentItem.type || documentItem.size) && (
                          <div className="document-list__file-info">
                            {documentItem.type && (
                              <span>{documentItem.type}</span>
                            )}
                            {documentItem.type && documentItem.size && ", "}
                            {documentItem.size && (
                              <span>{documentItem.size}</span>
                            )}
                          </div>
                        )}
                        {documentItem.updated && (
                          <div className="document-list__updated">
                            Updated: <span>{documentItem.updated}</span>
                          </div>
                        )}
                      </div>
                      <div className="document-list__bottom-right">
                        {documentItem.file ? (
                          <a
                            href={getStrapiMedia(documentItem.file.url)}
                            target="_blank"
                            className="document-icon-btn"
                          >
                            <img
                              src="/img/view.svg"
                              width="25"
                              height="14"
                              alt="View"
                            />
                          </a>
                        ) : (
                          ""
                        )}
                        {/*<a
                          href={getStrapiMedia(documentItem.file.url)}
                          target="_blank" className="document-icon-btn"
                        >
                          <img src="img/download.svg" width="22" height="20" alt="Download" />
                        </a>*/}
                      </div>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Documents;
